import styled from 'styled-components'

import { ServiceTypeSwitch } from '@components/ServiceTypeSwitch'

import type { AssetLogoProps } from './AutotaxLogos'
import { AutotaxLogo, AutotaxShortLogo } from './AutotaxLogos'
import { KafLogo } from './KafLogo'
import { KafShortLogo } from './KafShortLogo'

// An inline svg sits on the text baseline and adds a descender gap below it; the asset logos are
// already block, so without this the two brands take up different heights.
const BlockKafLogo = styled(KafLogo)`
  display: block;
`

const BlockKafShortLogo = styled(KafShortLogo)`
  display: block;
`

/** Full brand lockup for the active service type. */
export function ServiceTypeLogo(props: AssetLogoProps) {
  return <ServiceTypeSwitch autotax={<AutotaxLogo {...props} />} quickkeret={<BlockKafLogo {...props} />} />
}

/** Abbreviated mark for the active service type, for tight surfaces like the compact navbar. */
export function ServiceTypeShortLogo(props: AssetLogoProps) {
  return <ServiceTypeSwitch autotax={<AutotaxShortLogo {...props} />} quickkeret={<BlockKafShortLogo {...props} />} />
}
